import Router from 'vue-router'

import HerdSettings from "@/components/HerdSettings";
import ApplicationSettings from "@/components/ApplicationSettings";
import BackupSettings from "@/components/BackupSettings";


const router = new Router({
  mode: 'history',
  routes:  [
    {
      path: "/ustawienia/stada",
      component: HerdSettings
    },
    {
      path: "/ustawienia/aplikacji",
      component: ApplicationSettings
    },
    {
      path: "/ustawienia/kopii-zapasowej",
      component: BackupSettings
    }
  ]
})


export default router;